// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1ql0d","header":"PatientBlock_header__1iyx7","label":"PatientBlock_label__18ZM7","option":"PatientBlock_option__3_Ji3"};